const oidc = {
    logout_success: 'لقد قمت بتسجيل الخروج بنجاح.',
};
export default Object.freeze(oidc);
